import {
  LoadingSpinner,
  LoadingSpinnerBackground
} from './LoadingSpinnerComponent.style';
import React from 'react';

/**
 * The spinner that spins while data is loading
 * @constructor
 * @param {string} color the color of the loading spinner
 * @param {boolean} isLoading determines whether to show loading or not
 * @param {boolean} isRelative changes css position to relative if true(absolute otherwise) so that it can be positioned relative to its parent
 */
export const LoadingSpinnerComponent = ({ color, isLoading, isRelative }) => {
  const additionalProps = { isRelative };

  return isLoading ? (
    <LoadingSpinnerBackground {...additionalProps}>
      <LoadingSpinner color={color} {...additionalProps} />
    </LoadingSpinnerBackground>
  ) : null;
};



// WEBPACK FOOTER //
// ./src/components/common/Loading/LoadingSpinnerComponent.js